import { useState } from 'react';

import { Box } from 'components/Box';
import { Divider } from 'components/Divider';
import { Link } from 'components/Link';
import { H2 } from 'components/Text/H2';
import { HeadingSmall } from 'components/Text/HeadingSmall';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { CmsApiGradFairGradProgramLinksBlockData } from 'modules/cms/api/types/blocks/CmsApiGradFairGradProgramLinksBlock';
import { getIsContentFullWidthLayout } from 'modules/cms/helpers';
import { colors, gutterWidth } from 'theme';

import { CmsGradFairGradProgramLinksBlockToggleButton } from './CmsGradFairGradProgramLinksBlockToggleButton';

const LIMIT = 7;

type Props = {
  content: CmsApiPage;
  data: CmsApiGradFairGradProgramLinksBlockData;
};

export function CmsGradFairGradProgramLinksBlock({
  content,
  data: { orgs },
}: Props) {
  const fullWidthLayout = getIsContentFullWidthLayout({ content });
  const showButton = orgs.length > LIMIT;
  const [showAll, setShowAll] = useState(!showButton);

  const toggle = () => {
    setShowAll((prev) => !prev);
  };

  return (
    <Box
      data-qa-id="cms-grad-fair-grad-program-links"
      textAlign={fullWidthLayout ? 'center' : undefined}
    >
      <H2>{getText('Participating Programs')}</H2>

      <Box mt={[36, null, null, 48]} mb={-12}>
        {orgs
          .slice(0, showAll ? undefined : LIMIT)
          .map(({ id, name, program, url }) => (
            <Box
              key={id}
              py={12}
              width={fullWidthLayout ? [1, 1, 3 / 4] : undefined}
              mx="auto"
              data-qa-id="program-link"
            >
              {program && (
                <HeadingSmall color={colors.lightContentGrey} mb="8px">
                  {program?.schoolName}
                </HeadingSmall>
              )}

              <Link
                href={
                  program ? program.url[CURRENT_LOCALE] : url[CURRENT_LOCALE]
                }
              >
                {program ? program.name : name}
              </Link>
            </Box>
          ))}
      </Box>

      {showButton &&
        (fullWidthLayout ? (
          <Box position="relative">
            <Box width={[1, 3 / 4, 1 / 2]} mx="auto">
              <Divider marginTop={gutterWidth * 1.5} marginBottom={18} dashed />
            </Box>
            <Box
              position="absolute"
              left="50%"
              top="50%"
              transform="translate(-50%, -50%)"
            >
              <Box px={[12, null, 24]} bg="white">
                <CmsGradFairGradProgramLinksBlockToggleButton
                  showAll={showAll}
                  toggle={toggle}
                />
              </Box>
            </Box>
          </Box>
        ) : (
          <Box mt={gutterWidth}>
            <CmsGradFairGradProgramLinksBlockToggleButton
              showAll={showAll}
              toggle={toggle}
            />
          </Box>
        ))}
    </Box>
  );
}
